//#region Imports

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { InputField, SelectField } from 'react-semantic-redux-form';
import { Field, SubmissionError, formValueSelector, reduxForm } from 'redux-form';
import { Button, Form, Icon, Message, Transition } from 'semantic-ui-react';
import { getFurtherPageWithStatus } from '../../assets/js/route-utils';
import { TIPO_COTACAO_LABELS, TIPO_COTACAO_PLACEHOLDERS } from '../../assets/text/tipo-cotacao';
import FormLabel from '../../components/FormLabel';
import FormPopUp from '../../components/FormPopUp';
import { ModalTipoSimulacaoContext } from '../../components/ModalTipoSimulacao';
import DADOS_SIM from '../../consts/consts';
import ENUM from '../../consts/enum';
import FORMS from '../../consts/forms';
import { animationDuration, fadeAnimation } from '../../consts/system-const';
import TIPOS_COTACAO from '../../consts/tipos-cotacao';
import { emptySpaces } from '../../normalizers/normalize';
import SessionService from '../../session/session-service';
import { Creators as historicoAcessoCreators } from '../../store/ducks/historico-acesso';
import { Creators as listaBensCreator } from '../../store/ducks/lista-bens';
import { Creators as tipoSimulacaoCreators } from '../../store/ducks/tipo-simulacao';
import * as tipoSimulacaoService from './services/tipoSimulacaoService';
import styles from './styles.module.scss';
//#endregion

const forms = FORMS;
const selector = formValueSelector(forms.TIPO_SIMULACAO_MODAL);
const cotacaoValues = DADOS_SIM.DADOS_COTACAO;
const listaBemValues = DADOS_SIM.LISTA_BENS;
const tiposCotacao = TIPOS_COTACAO;
const tipoCotacaoPlaceholders = TIPO_COTACAO_PLACEHOLDERS;
const tipoCotacaoLabels = TIPO_COTACAO_LABELS;

class FormModalTipoSimulacao extends Component {
    chaveSegMais = SessionService.getChaveSegMais();
    chaveBroto = SessionService.getChaveBroto();
    statusCotacao = null;
    initialTipoCotacao = null;
    initialCodigoAcesso = null;
    disableForm = null;
    executedBrotoSteps = false;

    tipoCotacaoChanged = false;
    state = {
        loading: true,
        options: [],
        error: false,
        msgError: '',
        codAcesso: '',
        warning: false,
        listaBens: [],
        password: '',
        showPassword: false
    };

    get dadosCotacao() {
        return SessionService.getSession();
    }

    get codAcessoBroto() {
        const userBroto = SessionService.getUserBroto();
        return userBroto && userBroto[cotacaoValues.CODIGO_ACESSO];
    }

    /**
     * @Summary Inicializa o Componente
     */
    async componentDidMount() {
        const session = this.dadosCotacao;
        const { options, error, loading, msgError } = await tipoSimulacaoService.fetchData(this.chaveSegMais);

        if (session && session[cotacaoValues.ID_TIPO_COTACAO]) {
            this.statusCotacao = session[cotacaoValues.STATUS_COTACAO];
            this.initialTipoCotacao = session[cotacaoValues.ID_TIPO_COTACAO];
            this.initialCodigoAcesso = session[cotacaoValues.CODIGO_ACESSO];
            if (!this.codAcessoBroto) {
                this.populateFields(
                    options,
                    session[cotacaoValues.ID_TIPO_COTACAO],
                    session[cotacaoValues.CODIGO_ACESSO]
                );
            }
        }

        this.disableForm = Boolean(
            (this.statusCotacao && this.statusCotacao !== ENUM.STATUS_COTACAO.SIMULACAO_INICIADA) || this.codAcessoBroto
        );

        this.setState({ options, error, loading, msgError });
    }

    executeBrotoSteps(options) {
        const { handleSubmit } = this.props;
        const codAcessoBroto = this.codAcessoBroto;
        this.executedBrotoSteps = true;

        if (codAcessoBroto) {
            this.checkIfTipoCotacaoChanged(ENUM.TIPO_COTACAO.NEG_ESPECIAL, codAcessoBroto);
            this.populateFields(options, ENUM.TIPO_COTACAO.NEG_ESPECIAL, codAcessoBroto);

            setTimeout(() => handleSubmit((values) => this.submit(values, true))(), 500);
        }
    }

    /** For Broto */
    componentDidUpdate(prevProps) {
        if (((prevProps || {}).checkedForBroto !== this.props.checkedForBroto || !this.executedBrotoSteps) && this.state.options.length > 0) {
            this.executeBrotoSteps(this.state.options);
        }
    }

    populateFields(options, _idTipoCotacao, codigoAcesso) {
        const objSelected = options.find((element) => element.key === _idTipoCotacao);
        const idTipoCotacao = objSelected && objSelected.value;

        this.props.change(cotacaoValues.ID_TIPO_COTACAO, idTipoCotacao);
        this.props.change(cotacaoValues.CODIGO_ACESSO, codigoAcesso);
    }
    /**
     * @Summary Submita o Form
     */
    submit = async (values, fromBroto = false) => {
        const { objError, error } = tipoSimulacaoService.validarCampos(values);
        if (error) {
            throw new SubmissionError(objError);
        } else {
            if (values[cotacaoValues.ID_TIPO_COTACAO] === tiposCotacao.NEGOC_ESPEC) {
                try {
                    const responseSuccess = await tipoSimulacaoService.validarCodigoDeAcesso(values);
                    if (responseSuccess) {
                        this.props.dispatch(tipoSimulacaoCreators.setCodigoAcesso(values[cotacaoValues.CODIGO_ACESSO]));
                        if (!this.chaveSegMais && !this.chaveBroto) {
                            this.props.dispatch(
                                historicoAcessoCreators.setHistoricoAcesso(values[cotacaoValues.CODIGO_ACESSO])
                            );
                        }
                        this.avancarTela(values, fromBroto);
                    }
                } catch (error) {
                    this.disableForm = false;
                    throw new SubmissionError(error);
                }
            } else {
                this.avancarTela(values, fromBroto);
            }
        }
    };

    /**
     * @Summary Avança de Tela
     */
    avancarTela = (values, fromBroto) => {
        const { dispatch } = this.props;
        const { options } = this.state;

        let objTipoSimulacao = options.find((el) => el.value === values[cotacaoValues.ID_TIPO_COTACAO]);

        this.props.dispatch(tipoSimulacaoCreators.setTipoSimulacao(objTipoSimulacao.key));

        const idTipoCotacao = objTipoSimulacao.key;
        const codigoAcesso =
            idTipoCotacao === ENUM.TIPO_COTACAO.NEG_ESPECIAL ? values[cotacaoValues.CODIGO_ACESSO] : null;

        let sessionObj = {
            [cotacaoValues.ID_TIPO_COTACAO]: objTipoSimulacao.key,
            [cotacaoValues.CODIGO_ACESSO]: codigoAcesso
        };
        /** Reseta Lista Bens e Form Vigência ao modificar tipo de cotação */
        if (this.tipoCotacaoChanged) {
            dispatch(listaBensCreator.reset());
            sessionObj[listaBemValues.THIS] = null;
            sessionObj[listaBemValues.TIPO_VIGENCIA] = null;
        }
        /** Limpa o Broto se o usuário digitou na mão o Código de Acesso */
        if (!fromBroto) SessionService.clearCodAcessoBroto();
        SessionService.setSessionId(sessionObj[cotacaoValues.ID_TIPO_COTACAO]);
        SessionService.saveSession(sessionObj);
        this.pushFurther(this.statusCotacao);
    };

    pushFurther = () => {
        this.setState({ showHasSimModal: false });
        const statusCotacao = this.dadosCotacao && this.dadosCotacao[cotacaoValues.STATUS_COTACAO];
        this.props.history.push({
            pathname: getFurtherPageWithStatus(statusCotacao),
            redirect: true
        });
    };

    checkIfTipoCotacaoChanged = (idTipoCotacao, codigoAcesso) => {
        const { tipoVigenciaGlobal } = this.props;
        const listaBens = this.dadosCotacao && this.dadosCotacao[listaBemValues.THIS];
        const existListaBens = listaBens && listaBens.length > 0;
        const existVigencia =
            (this.dadosCotacao && this.dadosCotacao[listaBemValues.TIPO_VIGENCIA]) || tipoVigenciaGlobal;

        if (
            this.dadosCotacao &&
            (existListaBens || existVigencia) &&
            (idTipoCotacao !== this.initialTipoCotacao || codigoAcesso !== this.initialCodigoAcesso)
        ) {
            this.tipoCotacaoChanged = true;
            this.setState({
                warning: this.getWarningBody()
            });
        } else {
            this.tipoCotacaoChanged = false;
            this.setState({
                warning: null
            });
        }
    };

    handlerCodAcessoChange = (_, codAcesso) => {
        this.checkIfTipoCotacaoChanged(this.initialTipoCotacao, codAcesso);
    };

    onDropDownChange = (idTipoCotacao) => {
        this.checkIfTipoCotacaoChanged(idTipoCotacao, this.initialCodigoAcesso);
    };

    getWarningBody() {
        return (
            <>
                Aviso! Ao modificar o <b>Tipo de Simulação</b> ou a <b>Chave de Acesso</b> a <b>Lista de Bens</b> será
                perdida.
            </>
        );
    }

    getLabelTipoSim = () => (
        <FormPopUp
            label={tipoCotacaoLabels.TIPO_COTACAO}
            content={
                <div style={{ textAlign: 'center' }}>
                    Para a opção <b>Negociação Especial</b> é necessário informar o <b>Código de acesso</b>.
                </div>
            }
        />
    );

    getLabelCodAcess = () => (
        <FormPopUp
            label={tipoCotacaoLabels.CODIGO_ACESSO}
            content={
                <div style={{ textAlign: 'center' }}>
                    Informe o <b>Código de acesso</b> válido para a opção <b>Negociação Especial</b>.
                </div>
            }
        />
    );

    render() {
        const { options, loading, error, msgError, warning, showPassword } = this.state;
        const { tipo, handleSubmit, submitting } = this.props;
        const visible = tipo && tipo === tiposCotacao.NEGOC_ESPEC ? true : false;
        const selectTypePassword = showPassword ? 'text' : 'password';

        const selectIconPassword = showPassword ? (<Icon className='eye' />) : (<Icon className='eye slash icon' />);

        const handleClickShowPassword = () => {
            this.setState({ showPassword: !this.state.showPassword });
        };

        const handlePasswordChange = (prop) => (event) => {
            this.setState({ [prop]: event });
        };

        return (
            <React.Fragment>
                {error ? (
                    <Message negative>{msgError ? msgError : 'Ocorreu um erro! Por favor, tente novamente.'}</Message>
                ) : (
                    <>
                        <Form
                            className={styles.formModalTipoSimulacao}
                            loading={loading || submitting}
                            onSubmit={handleSubmit(this.submit)}
                        >
                            <Field
                                id={cotacaoValues.ID_TIPO_COTACAO}
                                name={cotacaoValues.ID_TIPO_COTACAO}
                                search={false}
                                label={FormLabel(this.getLabelTipoSim(), null, true)}
                                options={options}
                                component={SelectField}
                                placeholder={tipoCotacaoPlaceholders.TIPO_COTACAO}
                                onDrop={(e) => e.preventDefault()}
                                onChange={this.onDropDownChange}
                                disabled={this.disableForm}
                            />
                            <Transition
                                duration={animationDuration}
                                animation={fadeAnimation}
                                visible={visible}
                                className={styles.visibleTransitionOlho}
                            >
                                <div className={styles.divOlhoCodigoAcesso}>
                                    <div className={styles.visibleTransitionOlho}>
                                        <Field
                                            name={cotacaoValues.CODIGO_ACESSO}
                                            placeholder={tipoCotacaoPlaceholders.CODIGO_ACESSO}
                                            label={FormLabel(this.getLabelCodAcess(), null, true)}
                                            component={InputField}
                                            normalize={emptySpaces}
                                            maxLength='10'
                                            onDrop={(e) => e.preventDefault()}
                                            disabled={this.disableForm}
                                            value={this.state.password}
                                            onChange={handlePasswordChange('password')}
                                            type={selectTypePassword}
                                        />
                                        {
                                            <a className={styles.olho} onClick={handleClickShowPassword}>
                                                {selectIconPassword}
                                            </a>
                                        }
                                    </div>
                                </div>
                            </Transition>
                            <Button
                                className={styles.btnAvancar}
                                onClick={this.handlerSubmit}
                                loading={submitting}
                                disabled={submitting}
                                content='COMEÇAR'
                            />
                        </Form>
                        {warning && <Message warning>{warning}</Message>}
                    </>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    tipo: selector(state, cotacaoValues.ID_TIPO_COTACAO),
    tipoVigenciaGlobal: state.listaBensReducer[listaBemValues.TIPO_VIGENCIA]
});

const mapDispatchToProps = {};

FormModalTipoSimulacao = reduxForm({
    form: forms.TIPO_SIMULACAO_MODAL,
    destroyOnUnmount: true
})(FormModalTipoSimulacao);

FormModalTipoSimulacao.contextType = ModalTipoSimulacaoContext;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormModalTipoSimulacao));
